module.exports = __webpack_public_path__ + "media/logos/L_SES-d06f5274.png";